import { action, runInAction } from "mobx"
import { changeMsgStatus, getMsgList, deleteMsg } from "../api"
import messageStore from "../store/index"
import { reportUserBehaviorCgi } from "@/api/operator/cgi/smb/common"
import cookie from "@/utils/cookie"
import { REACT_APP_PUBLIC_URL } from "@/constants/Constants"

class MessageNotifyService {
  @action
  init = (agency_list) => {
    const agencyList = agency_list

    if ((agencyList[0] || {}).agency_uid) {
      messageStore.messageNotifyStore.config.agency_uid = (agencyList[0] || {}).agency_uid
      messageStore.messageNotifyStore.agencyList = agencyList
      this.getMsgList(false)
    }
  }

  // 改变 tabs 和分页
  @action
  handleTabsChange = (value) => {
    const conf = {
      ...messageStore.messageNotifyStore.config,
      page: 1,
    }
    switch (value) {
      case 1:
        conf.status = undefined
        conf.cate_id = undefined
        break
      case 2:
        conf.status = 1
        conf.cate_id = 0
        break
      case 3:
        conf.status = 0
        conf.cate_id = 1
        break
      case 4:
        conf.status = 0
        conf.cate_id = 2
        break
      case 5:
        conf.status = 0
        conf.cate_id = 3
        break
      case 6:
        conf.status = 0
        conf.cate_id = 4
        break
    }
    messageStore.messageNotifyStore.config = conf
    messageStore.messageNotifyStore.tabsValue = value

    this.getMsgList()
  }

  // 获取消息列表
  @action
  getMsgList = (flag) => {
    if (!flag) {
      messageStore.messageNotifyStore.notifyData = {
        loadingShow: true,
      }
    }

    return getMsgList({
      data: messageStore.messageNotifyStore.config,
    }).then(
      (res) => {
        let result
        if (res.code === 0) {
          result = {
            ...res.data,
            loadingShow: false,
          }
        } else {
          result = {
            loadingShow: false,
          }
        }
        runInAction(() => {
          messageStore.messageNotifyStore.notifyData = result
        })
      },
      (err) => {
        runInAction(() => {
          messageStore.messageNotifyStore.notifyData = {
            loadingShow: false,
          }
        })
      }
    )
  }

  @action
  handlePagesChange = (value) => {
    messageStore.messageNotifyStore.config = {
      ...messageStore.messageNotifyStore.config,
      page: value,
    }
    this.getMsgList(false)
  }

  // 改变消息状态
  @action
  handleOpen = (msgId, status) => {
    const conf = messageStore.messageNotifyStore.config
    let obj = {}
    const originList = messageStore.messageNotifyStore.notifyData.list
    originList.forEach((notify) => {
      if (notify.msg_id == msgId) {
        notify.status = 2
        obj = notify
      }
    })
    reportUserBehaviorCgi({
      data: {
        behavior: "点击通知列表",
        page1: "公告中心",
        relation_id: msgId,
        relation_type: "message",
        relation_name: obj.title,
      },
    })

    if (status != 2) {
      reportUserBehaviorCgi({
        data: {
          behavior: "阅读未读消息",
          page1: "公告中心",
          relation_id: msgId,
          relation_type: "notice",
          relation_name: obj.title,
        },
      })
    }

    return changeMsgStatus({
      data: {
        msg_id: msgId,
        agency_uid: conf.agency_uid,
      },
    }).then(
      (res) => {
        if (res.code !== 0) {
          messageStore.messageNotifyStore.notifyData.list = originList
        }
      },
      (err) => {
        messageStore.messageNotifyStore.notifyData.list = originList
      }
    )
  }

  // 删除消息
  deleteMsg = (msgId) => {
    return deleteMsg({
      data: {
        msg_id: msgId,
        agency_uid: messageStore.messageNotifyStore.config.agency_uid,
      },
    }).then((res) => {
      if (res.code == 0) {
        this.getMsgList(false)
      }
    })
  }

  // 切换服务商
  @action
  agencyChange = (e, agency_uid) => {
    messageStore.messageNotifyStore.config = {
      ...messageStore.messageNotifyStore.config,
      agency_uid,
    }
    this.getMsgList(false)
  }

  // 处理数据
  handleShowContent = (text) => {
    const agency_uid = cookie.get("agency_uid")
    return text.replace(/\/agency\/#gdtpath=createclient&uid=(\d+)/, `${REACT_APP_PUBLIC_URL}/agency/advertiser-add-account?uid=$1&agencyUid=${agency_uid}`).replace(/\/URL_MESSAGE_DETAIL/, `${REACT_APP_PUBLIC_URL}/agency/finance-info/tencent`)
  }
}

export default new MessageNotifyService()
